<img width="100%" src="{{ assetsUrl('/assets/images/skeletons/' + (deviceService.isMobile() ? stats + '-mobile' : stats) +'.png') }}" [alt]="stats">
